const filterGroups = document.querySelectorAll('.section-products__filters .filter-group');

filterGroups.forEach(group => {
  const button = group.querySelector('button');
  const dropdown = group.querySelector('ul');


  dropdown.style.display = 'none';

  button.addEventListener('click', function (e) {
    e.stopPropagation();
    const isVisible = dropdown.style.display === 'block';

    document.querySelectorAll('.filter-group ul').forEach(ul => ul.style.display = 'none');
    dropdown.style.display = isVisible ? 'none' : 'block';
  });
});

document.addEventListener('click', function (e) {
  document.querySelectorAll('.filter-group ul').forEach(ul => ul.style.display = 'none');
});

// products Filter
const checkboxes = document.querySelectorAll('.filter-checkbox');
const productCards = document.querySelectorAll('.product');
const resultsCounter = document.querySelector('.section-products__results .count');
const activeFiltersList = document.querySelector('.active-filters-list');

function getCheckedValues(type) {
  return Array.from(document.querySelectorAll(`input[data-filter-type="${type}"]:checked`)).map(cb => cb.value);
}

function updateResults() {
  const selectedManufacturers     = getCheckedValues('manufacturer');
  const selectedCuts               = getCheckedValues('cut');
  const selectedColors             = getCheckedValues('color');
  let visibleCount = 0;

  productCards.forEach(card => {
    const cardManufacturers = card.dataset.manufacturer.split(' ');
    const cardCuts = card.dataset.cut.split(' ');
    const cardColors = card.dataset.color.split(' ');

    const matchesManufacturer = selectedManufacturers.length === 0 || selectedManufacturers.some(val => cardManufacturers.includes(val));
    const matchesCut = selectedCuts.length === 0 || selectedCuts.some(val => cardCuts.includes(val));
    const matchesColor = selectedColors.length === 0 || selectedColors.some(val => cardColors.includes(val));

    const visible = matchesManufacturer && matchesCut && matchesColor;
    card.style.display = visible ? 'block' : 'none';

    if (visible) visibleCount++;
  });

  resultsCounter.textContent = visibleCount;
  renderActiveFilters();
}

function renderActiveFilters() {
  if (!activeFiltersList) return;

  activeFiltersList.innerHTML = '';

  const checked = document.querySelectorAll('.filter-checkbox:checked');
  if (checked.length === 0) return;

  checked.forEach(cb => {
    const label = cb.parentElement.textContent.trim();
    const tag = document.createElement('span');
    tag.className = 'active-filter-tag';
    tag.textContent = label;

    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'remove-filter';
    removeBtn.innerHTML = '&times;';
    removeBtn.addEventListener('click', () => {
      cb.checked = false;
      updateResults();
    });

    tag.appendChild(removeBtn);
    activeFiltersList.appendChild(tag);
  });
}

checkboxes.forEach(cb => {
  cb.addEventListener('change', updateResults);
});

updateResults();